import api from '@/utils/axios';

/**
 * 크레딧 호가 관련 API 서비스 (기존 askService 유지)
 * - 크레딧 매도 호가 조회
 * - 매수 호가 조회
 * - 호가별 상세 정보 조회
 * - 미분류 호가 조회
 * - 만기일 할당
 */
const askService = {
  async findCreditSell(
    date,
    creditType,
    { minMonths, maxMonths, searchKeyword }
  ) {
    try {
      const {
        onSaleQuotes,
        soldOutQuotes
      } = await api.get('/api/v1/quote/credit', {
        date: date,
        creditType: creditType,
        minMonths: minMonths,
        maxMonths: maxMonths,
        searchKeyword: searchKeyword,
      });
      return {
        onSaleQuotes: Array.isArray(onSaleQuotes)
          ? onSaleQuotes.map(quote => {
              return {
                // 호가 정보
                id: quote.creditQuoteId,
                creditQuoteId: quote.creditQuoteId,
                status: quote.status,
                appearanceTime: quote.appearanceTime,
                content: quote.latestChatContent,
                spreadHint: quote.spreadHint,
                
                // 종목 정보
                bondId: quote.bondId,
                code: quote.code,
                bondName: quote.bondName,
                bondIssuerId: quote.bondIssuerId,
                maturityDate: quote.maturityDate,
                issueDate: quote.issueDate,
                yield: quote.yield,
                grade: quote.grade,
                isEsg: quote.esg,
                hasComplianceRisk: quote.hasComplianceRisk,
                leadManagers: quote.leadManagers,
                underwriters: quote.underwriters,
                couponRate: quote.couponRate,
                
                // 라벨 정보
                labelIds: quote.labelIds,
              };
            })
          : [],
        soldOutQuotes: Array.isArray(soldOutQuotes)
          ? soldOutQuotes.map(quote => {
              return {
                // 호가 정보
                id: quote.creditQuoteId,
                creditQuoteId: quote.creditQuoteId,
                status: quote.status,
                appearanceTime: quote.appearanceTime,
                content: quote.latestChatContent,
                spreadHint: quote.spreadHint,
                
                // 종목 정보
                bondId: quote.bondId,
                code: quote.code,
                bondName: quote.bondName,
                bondIssuerId: quote.bondIssuerId,
                maturityDate: quote.maturityDate,
                issueDate: quote.issueDate,
                yield: quote.yield,
                grade: quote.grade,
                isEsg: quote.esg,
                hasComplianceRisk: quote.hasComplianceRisk,
                leadManagers: quote.leadManagers,
                underwriters: quote.underwriters,
                couponRate: quote.couponRate,
                
                // 체결 정보
                hasTraded: quote.hasTraded,
                representationTradingYield: quote.representationTradingYield,
                spreadYield: quote.spreadYield,
                spreadPrice: quote.spreadPrice,
                hasWidePriceGap: quote.hasWidePriceGap,
                priceBeforeTax: quote.priceBeforeTax,
                
                // 지표 스프레드 정보
                hasBenchmarkTx: quote.hasBenchmarkTx,
                benchmarkBondType: quote.benchmarkBondType,
                benchmarkMaturityRangeType: quote.benchmarkMaturityRangeType,
                benchmarkSpread: quote.benchmarkSpread,
                benchmarkVsSpread: quote.benchmarkVsSpread,
                benchmarkTransactionDateTime: quote.benchmarkTransactionDateTime,
                
                // 라벨 정보
                labelIds: quote.labelIds,
              };
            })
          : [],
        
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async findUncategorizedSellAsk(date) {
    try {
      const data = await api.get('/api/v1/chat/uncategorized', {
        date: date,
      });
      return Array.isArray(data)
        ? data.map(ask => {
            return {
              id: ask.chatId,
              content: ask.content,
            };
          })
        : [];
    } catch (error) {
      console.error(error);
    }
  },
  async findBuyAsk(date) {
    try {
      const data = await api.get('/api/v1/quote/credit/buy', {
        date: date,
      });
      return Array.isArray(data)
        ? data.map(ask => {
            return {
              chatId: ask.chatId,
              content: ask.content,
              chatDateTime: ask.chatDateTime,
              senderName: ask.senderName,
              senderAddress: ask.senderAddress,
              bondType: ask.bondType,
              creditType: ask.creditType,
            };
          })
        : [];
    } catch (error) {
      console.error(error);
    }
  },
  async assignMaturity(ids, maturityDate) {
    try {
      await api.patch('/api/v1/chat/assign-maturity', {
        ids: ids,
        maturityDate: maturityDate,
      });
    } catch (error) {
      console.error(error);
    }
  },
  async findCreditOnSale(creditQuoteId) {
    try {
      await api.get(`/api/v1/quote/credit/${creditQuoteId}/on-sale`);
    } catch (error) {
      console.error(error);
    }
  },

  async findCreditSoldOut(creditQuoteId) {
    try {
      const data = await api.get(
        `/api/v1/quote/credit/${creditQuoteId}/sold-out`
      );
      return Array.isArray(data)
        ? data.map(tx => {
            return {
              id: tx.id,
              originalBondName: tx.originalBondName,
              bondIssuerId: tx.bondIssuerId,
              grade: tx.grade,
              maturityDate: tx.maturityDate,
              transactionDateTime: tx.transactionDateTime,
              yield: tx.yield,
              tradingYield: tx.tradingYield,
              tradingPrice: tx.tradingPrice,
              transactionVolume: tx.transactionVolume,
              spreadBp: tx.spreadBp,
              spreadPrice: tx.spreadPrice,
              price: tx.price,
            };
          })
        : [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async findAskChats(askId) {
    try {
      const data = await api.get(`/api/v1/quote/credit/${askId}/chats`);
      return Array.isArray(data)
        ? data.map(chat => {
            return {
              content: chat.content,
              senderName: chat.senderName,
              senderAddress: chat.senderAddress,
              chatDateTime: chat.chatDateTime,
            };
          })
        : [];
    } catch (error) {
      console.error(error);
    }
  },
};
export default askService;
